export enum FieldDefValidations {
    TEXT = "TEXT",
    COMBOBOX = "COMBOBOX",
    CHECKBOX = "CHECKBOX",
    CHECKLIST = "CHECKLIST",
    CHECKLISTEDIT = "CHECKLISTEDIT",
    DURATION = "DURATION",
    NUMBER = "NUMBER",
    DATE = "DATE",
    TIME = "TIME",
    COLLECTION = "COLLECTION",
    FORM = "FORM",
    SPECIAL = "SPECIAL",
    TREE = "TREE",
    DUAL = "DUAL",
    TABLE = "TABLE",
    MOSDATETIME = "MOSDATETIME",
    MOSDURATION = "MOSDURATION",
    MOSAUTOMATION = "MOSAUTOMATION",
    MOSAUTOMATIONDURATION = "MOSAUTOMATIONDURATION",
    STAFFIDLIST = "STAFFIDLIST",
    LOOKUPLIST = "LOOKUPLIST",
    ADDRESS = "ADDRESS",
    COST = "COST",
    LOCATIONLIST = "LOCATIONLIST",
    VIEWSTATEORDER = "VIEWSTATEORDER",
    DATETIMERANGE = "DATETIMERANGE",
    WEBHOOKSIDLIST = "WEBHOOKSIDLIST"
}